import React from 'react';
export function ClosingSection() {
  return <section className="w-full border-b border-line bg-paper" data-id="element-32" data-mp="1fe71qlomjhxr">
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-5 sm:py-16 lg:py-20" data-id="element-33" data-mp="ou44kd2sh4qi">
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-rust sm:text-xs" data-id="element-34" data-mp="12td7wc5wc4d2">
          Final thoughts
        </p>
        <h2 className="mt-3 font-display text-2xl font-semibold leading-tight tracking-tight text-ink sm:mt-4 sm:text-4xl" data-id="element-35" data-mp="xsz6hcysvso0">
          The clock is ticking.
        </h2>
        <p className="mt-5 text-[15px] leading-relaxed text-ink-soft sm:mt-6 sm:text-lg" data-id="element-36" data-mp="17sgbds68a2ix">
          Tomorrow you can go back to spending hours searching for worksheets… or you can have your
          entire year of teaching material ready in the next 60 seconds.
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-37" data-mp="1vhiu73clm1f0">
          You’ve spent years mastering your instrument. You deserve a teaching system that matches
          your musicianship.
        </p>
        <p className="mt-7 font-display text-lg font-semibold text-ink sm:mt-8 sm:text-2xl" data-id="element-38" data-mp="22cvuckdmmfmy">
          Stop the Sunday scramble. Start the system.
        </p>
      </div>
    </section>;
}